<template>
  <div class="course-type">
    <div v-if="showType==='all'||showType=='1'">
      <Checkbox
        v-model="quelityType"
        :disabled="disabled"
        @on-change="onQuelityTypeChange"
      >素质课程</Checkbox>
      <div style="padding-left: 32px">
        <CheckboxGroup
          v-model="formValidate.quelityType"
          @on-change="onQuelityTypeAllChange"
        >
          <Checkbox
            v-for="(item, index) in quelityTypeList"
            :key="item.value"
            :label="item.value"
            :disabled="disabled"
          >{{ item.label }}</Checkbox>
        </CheckboxGroup>
      </div>
    </div>
    <div v-if="showType==='all'||showType=='2'">
      <Checkbox
        v-model="hostingType"
        :disabled="disabled"
        @on-change="onHostingTypeChange"
      >托管课程</Checkbox>
      <div style="padding-left: 32px">
        <CheckboxGroup
          v-model="formValidate.hostingType"
          @on-change="onHostingTypeAllChange"
        >
          <Checkbox
            v-for="(item, index) in hostingTypeList"
            :key="item.value"
            :label="item.value"
            :disabled="disabled"
          >{{ item.label }}</Checkbox>
        </CheckboxGroup>
      </div>
    </div>

  </div>
</template>

<script>
import { quelityTypeList, hostingTypeList } from '@/utils/dictionary.js';
export default {
  props: {
    typeIds: {
      type: Array,
      default: () => []
    },
    disabled: {
      type: Boolean,
      default: false
    },
    showType: {
      type: String || Number,
      default: 'all'
    }
  },
  data() {
    return {
      quelityTypeList: quelityTypeList.slice(1, quelityTypeList.length), // 课程类型-素质
      hostingTypeList: hostingTypeList.slice(1, hostingTypeList.length), // 课程类型-托管
      quelityType: false,
      hostingType: false,
      formValidate: {
        quelityType: [],
        hostingType: []
      }
    };
  },
  watch: {
    typeIds: {
      handler(newValue) {
        this.handleInitIds(newValue);
      },
      deep: true,
      immediate: true
    },
    formValidate: {
      handler(newValue) {
        console.log(newValue, 'formValidate');
        this.$emit('on-change', this.getResult());
      },
      deep: true

    }
  },
  methods: {
    // 获取结果
    getResult() {
      return {
        quelityType: [...this.formValidate.quelityType],
        hostingType: [...this.formValidate.hostingType],
        typeIds: [
          ...this.formValidate.quelityType,
          ...this.formValidate.hostingType
        ]
      };
    },
    // 清除
    handleClear() {
      this.formValidate.quelityType = [];
      this.formValidate.hostingType = [];
      this.hostingType = false;
      this.quelityType = false;
    },
    handleInitIds(typesIds) {
      this.formValidate.hostingType = [];
      this.formValidate.quelityType = [];
      typesIds.forEach((item) => {
        if (item >= 20) {
          this.formValidate.hostingType.push(String(item));
        } else {
          this.formValidate.quelityType.push(String(item));
        }
      });
      this.onQuelityTypeAllChange(this.formValidate.quelityType);
      this.onHostingTypeAllChange(this.formValidate.hostingType);
    },
    // 素质课程
    onQuelityTypeChange(val) {
      if (val) {
        this.formValidate.quelityType = this.quelityTypeList.map((item) => {
          return item.value;
        });
      } else {
        this.formValidate.quelityType = [];
      }
    },
    onQuelityTypeAllChange(val) {
      if (val.length == this.quelityTypeList.length) {
        this.quelityType = true;
      } else {
        this.quelityType = false;
      }
    },
    // 托管课程
    onHostingTypeChange(val) {
      if (val) {
        this.formValidate.hostingType = this.hostingTypeList.map((item) => {
          return item.value;
        });
      } else {
        this.formValidate.hostingType = [];
      }
    },
    onHostingTypeAllChange(val) {
      if (val.length == this.hostingTypeList.length) {
        this.hostingType = true;
      } else {
        this.hostingType = false;
      }
    }
  }
};
</script>

<style></style>
